export enum GaEventType {
    pageview = "pageview",
    event = "event"
}
